import {
  AppBar,
  Logout,
  UserMenu,
  useRedirect,
  useSidebarState,
  useTranslate,
} from "react-admin";
import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { COLLAPSED_WIDTH, SIDEBAR_WIDTH } from "@/constants/resources";
import { useState } from "react";
import { DialogConsumeVoucher } from "../dialogconsumevoucher";
import { useRole } from "@/hooks/userRole";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import InventoryIcon from "@mui/icons-material/Inventory";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import PercentIcon from "@mui/icons-material/Percent";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

const voucherChoices = [
  {
    label: "Bon d'achat",
    path: "/giftcards/create",
    icon: <CardGiftcardIcon />,
  },
  {
    label: "Produit offert",
    path: "/productsoffered/create",
    icon: <InventoryIcon />,
  },
  {
    label: "Buy One, Get One",
    path: "/bogo/create",
    icon: <ContentCopyIcon />,
  },
  {
    label: "Réduction sur addition",
    path: "/discount/create",
    icon: <PercentIcon />,
  },
];

const MyCustomIcon = () => (
  <Avatar
    sx={{
      height: 30,
      width: 30,
    }}
  >
    <AccountCircleIcon />
  </Avatar>
);

const CustomAppBar = () => {
  const [open] = useSidebarState();
  const [openDialog, setOpenDialog] = useState(false);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const redirect = useRedirect();
  const { role } = useRole();
  const translate = useTranslate();

  return (
    <AppBar
      sx={{
        width: `calc(100% - ${open ? SIDEBAR_WIDTH : COLLAPSED_WIDTH}px)`,
        ml: `${open ? SIDEBAR_WIDTH : COLLAPSED_WIDTH}px`,
        backgroundColor: "#fff",
        boxShadow: "none",
        borderBottom: "1px solid #e0e0e0",
        "& .RaAppBar-toolbar": {
          padding: "15px",
          justifyContent: "flex-end",
        },
        "& .RaAppBar-toolbar .RaRefreshButton": {
          display: "none",
        },
        "& .MuiIconButton-root": {
          color: "#6C0088",
        },
      }}
      userMenu={
        <UserMenu icon={<MyCustomIcon />}>
          <Logout />
        </UserMenu>
      }
    >
      {(role === "cashier" || role === "entity") && (
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpenDialog(true)}
          >
            {translate("ra.gameoo.consumeVoucher")}
          </Button>
          {role === "entity" && (
            <Button
              variant="outlined"
              color="primary"
              startIcon={<AddCircleOutlineIcon />}
              onClick={() => setOpenCreateDialog(true)}
            >
              {translate("ra.gameoo.newVoucher")}
            </Button>
          )}
          <DialogConsumeVoucher
            open={openDialog}
            onClose={() => setOpenDialog(false)}
          />
          <Dialog
            open={openCreateDialog}
            onClose={() => setOpenCreateDialog(false)}
            fullWidth
            maxWidth="xs"
          >
            <DialogTitle>Choisir le type de récompense</DialogTitle>
            <DialogContent dividers>
              <Stack spacing={1.5}>
                {voucherChoices.map((choice) => (
                  <Button
                    key={choice.path}
                    variant="outlined"
                    fullWidth
                    startIcon={choice.icon}
                    onClick={() => {
                      setOpenCreateDialog(false);
                      redirect(choice.path);
                    }}
                    sx={{
                      justifyContent: "flex-start",
                      padding: 1.5,
                      textTransform: "none",
                      fontSize: "1rem",
                      borderColor: "#e2c5e9",
                      color: "#333",

                      "& .MuiButton-startIcon": {
                        color: "#6C0088",
                        marginRight: 1.5,
                      },

                      "&:hover": {
                        borderColor: "#6C0088",
                        backgroundColor: "rgba(108, 0, 136, 0.06)",
                      },
                    }}
                  >
                    {choice.label}
                  </Button>
                ))}
              </Stack>
            </DialogContent>

            <DialogActions>
              <Button onClick={() => setOpenCreateDialog(false)}>
                Annuler
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      )}
    </AppBar>
  );
};

export default CustomAppBar;
